import React from "react";
import DPCheckbox from "Components/DP/DPCheckbox/DPCheckbox";
import UserFilterCheckboxIcon from "./UserFilterCheckboxIcon";

export interface FilterOptionsGroupOption {
  key: string;
  label: string;
  selected: boolean;
}

export interface FilterOptionsGroupProps {
  options: FilterOptionsGroupOption[];
  onChange: (id: string, newValue: boolean) => void;
}

export function FilterOptionsGroup(props: FilterOptionsGroupProps) {
  const { options, onChange } = props;
  return (
    <>
      {
        options.map(option => (
          <DPCheckbox
            key={option.key}
            icon={<UserFilterCheckboxIcon />}
            label={option.label}
            checked={option.selected}
            onChange={() => {
              onChange(option.key, !option.selected);
            }}
          />
        ))
      }
    </>
  );
}
